const y = (n) => n.displayName || n.name || "Component", c = (n, a) => {
  const s = (r, e, t = /* @__PURE__ */ new WeakSet()) => Array.isArray(r) && Array.isArray(e) ? r.length !== e.length || r.some((o, f) => s(o, e[f], t)) : r && e && typeof r == "object" && typeof e == "object" ? t.has(r) || t.has(e) ? !1 : (t.add(r), t.add(e), Object.keys(e).some((o) => s(r[o], e[o], t))) : r !== e;
  return s(n, a);
};
export {
  y as g,
  c as h
};
